import { createAction, props } from '@ngrx/store';
import { Organization } from 'src/app/internal-user/customer-management/models/organization';

export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAILURE = 'GET_ORGANIZATIONS_FAILURE';

export const getOrganizations = createAction(GET_ORGANIZATIONS);
export const getOrganizationsSuccess = createAction(GET_ORGANIZATIONS_SUCCESS, props<{organizations: Organization[]}>());
export const getOrganizationsFailure = createAction(GET_ORGANIZATIONS_FAILURE, props<{error: any}>());